import React from 'react';
import { Card, Col, Row } from 'reactstrap';

import ImageExpand from '../ImageExpand';
import FlipAnswer from './FlipAnswer';

export default class FCard extends React.Component {
  render() {
    const correctAnswer = this.props.answers.filter(
      (answers) => answers.correct,
    )[0];

    return (
      <Row className="mt-lg-4 mt-sm-0 mcard">
        <Col className="col-12">
          <Card>
            <div className="d-flex flex-md-row flex-column flex-sm-column justify-content-center">
              <ImageExpand imageUrl={this.props.imageUrl} />
              <FlipAnswer
                getClickedState={this.props.getClickedState}
                setClicked={this.props.setClicked}
                answer={correctAnswer || { text: '', id: 0 }}
              />
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}
